module.exports = __webpack_public_path__ + "static/media/chevron-right.c297095b.svg";